import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { useNormativesApi } from "../../../../../http/border/useNormatives";
import FlexContent from "../../../../ui/FlexContent";
import Header from "../../../../ui/Header";
import { BORDER } from "../../AdminSystemSettings";
import NormativeDetails from "./NormativeDetails";

const Normative: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { normativeId } = useParams<{ normativeId: string }>();
  const normativesApi = useNormativesApi();

  const aborter = useRef(new AbortController());
  const { error, data, isMutating, trigger } = normativesApi.getAdminNormative(normativeId!, aborter.current.signal);

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: BORDER },
    {
      url: `/admin/systems/${systemId}/settings?tab=1`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.normatives.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    normativeId && trigger();
  }, [normativeId]);

  return (
    <>
      <Header title={`${i18n.translation.normatives.singular}: ${data?.name ?? ""}`} error={error} path={path} />
      <FlexContent padding direction="row">
        <NormativeDetails normative={!error ? data : undefined} disabled={isMutating || !!error} />
      </FlexContent>
    </>
  );
};

export default Normative;
